import { render, staticRenderFns } from "./label.vue?vue&type=template&id=137164ec&scoped=true"
import script from "./label.vue?vue&type=script&setup=true&lang=js"
export * from "./label.vue?vue&type=script&setup=true&lang=js"
import style0 from "./label.vue?vue&type=style&index=0&id=137164ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137164ec",
  null
  
)

export default component.exports